export enum ImportLogActionTypesEnum {
    SET_IMPORT_LOGS = 'import-log/set-import-logs',
    SET_CURRENT_IMPORT_LOG = 'import-log/set-current-import-log',
    SET_CURRENT_IMPORT_LOG_DETAIL = 'import-log/set-current-import-log-details',
}
